import React from 'react';
import {Link} from "react-router-dom";

const ContactUsContent = () => {
  return (
    <>
      <section className='pt-40 pb-120'>
        <div className='container'>
          <div
            className='bg-dark ptb-60 px-5 position-relative overflow-hidden rounded-custom'
            style={{
              background:
                "url('assets/img/page-header-bg.svg')no-repeat center bottom",
            }}
          >
            <div className='row justify-content-center'>
              <div className='col-lg-8 col-md-9'>
                <div className='subscribe-info-wrap text-center position-relative z-2'>
                  <div className='section-heading'>
                    <h2>Your competitive edge in every transaction</h2>
                    <p>
                      We can help you to receive payments that power your growth and increase
                      business revenue.
                    </p>
                  </div>
                  <div className='form-block-banner mw-60 m-auto mt-5'>
                    <form
                      id='email-form2'
                      name='email-form'
                      className='subscribe-form'
                    >
                      {/*<input*/}
                      {/*  type='submit'*/}
                      {/*  value='Contact us'*/}
                      {/*  data-wait='Please wait...'*/}
                      {/*  className='btn btn-primary'*/}
                      {/*/>*/}
                      <Link
                          to="/contact-us"
                          className="btn ail-gd-bg dark-bg-hover rounded-5 text-white fs-16 border-0 mt-20"
                      >
                        Contact us
                      </Link>
                    </form>
                  </div>
                </div>
              </div>
            </div>
            <div className='bg-circle rounded-circle circle-shape-1 position-absolute bg-dark-light left-5'></div>
          </div>
        </div>
      </section>
    </>
  );
};

export default ContactUsContent;
